import { inject, Injector, runInInjectionContext } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes, GamesRoutes, HostedGamesRoutes, LocalStorageKey, TeamsRoutes } from '@core';
import { TeamInvitationPayload } from '../../../../../teams/src/lib/application/models';
import { ReassignGamePayload } from '../../../../../hosted-games/src/lib/application/interfaces';

export const redirectAfterLoginUtil = (injector: Injector): Promise<boolean> => {
  const sharedGameId: string | null = sessionStorage.getItem(LocalStorageKey.SharedGame);
  const teamInvitationAccept: TeamInvitationPayload = JSON.parse(
    sessionStorage.getItem(LocalStorageKey.TeamInvitationAccept) as string
  );
  const reassignGame: ReassignGamePayload = JSON.parse(sessionStorage.getItem(LocalStorageKey.ReassignGame) as string);

  return runInInjectionContext(injector, () => {
    const router: Router = inject(Router);

    if (sharedGameId) {
      return router.navigate([`/${AppRoutes.GAMES}/${GamesRoutes.SHARED}/${sharedGameId}`]);
    }

    if (teamInvitationAccept) {
      const url: string = `${AppRoutes.TEAMS}/${TeamsRoutes.ACCEPT_INVITATION}/${teamInvitationAccept.teamId}/${teamInvitationAccept.token}`;

      return router.navigate([url]);
    }

    if (reassignGame) {
      const url: string = `${AppRoutes.HOST}/${HostedGamesRoutes.REASSIGN}/${reassignGame.gameId}`;

      return router.navigate([url], { queryParams: { token: reassignGame.token } });
    }

    return router.navigate([`/${AppRoutes.ROOT}`]);
  });
};
